import {PageView} from '../layouts'
import {isInMobile} from "@/utils/validate";

export const parameter = {
  path: '/parameter',
  redirect: '/parameter/parameterList',
  meta: {title: '系统参数', icon: 'code', isMenuShow: true, permission: 'sysp'},
  component: PageView,
  children: [
    {
      path: '/parameter/parameterList',
      name: 'parameter',
      component: () => import('../views/parameter/parameterList.vue'),
      meta: {title: '参数列表', icon: 'dollar', isMenuShow: true, permission: 'sysp:list'},
    },
    !isInMobile() ? {
      path: '/parameter/logList',
      name: 'parameter',
      component: () => import('../views/parameter/logListHome.vue'),
      meta: {title: 'App车控日志', icon: 'dollar', isMenuShow: true, permission: 'sysp:loglist'},
    } : {
      path: '/parameter/logList',
      name: 'parameter',
      component: () => import('../views/parameter/logListHome-h5.vue'),
      meta: {title: 'App车控日志', icon: 'dollar', isMenuShow: true, permission: 'sysp:loglist'},
    },
    {
      path: '/parameter/parameterAdd',
      name: 'parameterAdd',
      component: () => import('../views/parameter/parameterAdd.vue'),
      meta: {title: '新增参数', icon: 'dollar', isMenuShow: false, permission: 'sysp:list:add'},
    },
    {
      path: '/parameter/parameterUpdate',
      name: 'parameterUpdate',
      component: () => import('../views/parameter/parameterAdd.vue'),
      meta: {title: '修改参数', icon: 'dollar', isMenuShow: false, permission: 'sysp:list:alter'},
    },
    !isInMobile() ?
        {
          path: '/parameter/sevenLogList',
          name: 'parameter',
          component: () => import('../views/parameter/sevenLogList.vue'),
          meta: {title: 'App蓝牙日志文件查看', icon: 'dollar', isMenuShow: true, permission: 'sysp:loglist'},
        } :
        {
          path: '/parameter/sevenLogList',
          name: 'parameter',
          component: () => import('../views/parameter/sevenLogList-h5.vue'),
          meta: {title: 'App蓝牙日志文件查看', icon: 'dollar', isMenuShow: true, permission: 'sysp:loglist'},
        },
    {
      path: '/parameter/dictionary',
      name: 'dictionary',
      component: () => import('../views/parameter/dictionary.vue'),
      meta: {title: '编码词典', icon: 'dollar', isMenuShow: true, permission: 'sysp:loglist:changeCode'},
    },
  ]
}
